import React from "react";

const ModelSelectorContext = React.createContext({
    translatedTexts: {} as Record<string, string>,
    isLoading: true,
    setIsLoading: (_isLoading: boolean) => {},
});

export default ModelSelectorContext;
